import React from "react";
import './servicesGrid.scss'
import AppIcons from "../../assets/images/icons";


function ServicesGrid() {

  const serviceListing = [
    {
      serviceIcon: AppIcons.serviceBuy,
      serviceTitle: 'Buy',
      Description: 'Expert support from search to signing. We help you find, evaluate, and secure the right property — the smart way.',
    },
    {
      serviceIcon: AppIcons.serviceMor,
      serviceTitle: 'Mortgage',
      Description: "From pre-approval to closing, our mortgage experts offer tailored solutions to secure the best financing for your Dubai property.",
    },
    {
      serviceIcon: AppIcons.serviceSell,
      serviceTitle: 'Sell',
      Description: "Sell your property fast and smart — with expert valuation, marketing, and buyer matching built in.",
    },
    {
      serviceIcon: AppIcons.serviceRent,
      serviceTitle: 'Rent',
      Description: 'From search to signing. Our experts make renting in Dubai smooth, secure, and suited to your lifestyle.',
    },
    {
      serviceIcon: AppIcons.serviceProp,
      serviceTitle: 'Property Management',
      Description: "We handle everything — from tenant screening to rent collection — so you can earn passively, stress-free.",
    },
    {
      serviceIcon: AppIcons.serviceValuation,
      serviceTitle: 'Property Valuation',
      Description: "Precision matters. We provide accurate, market-driven property valuations to help you make informed decisions.",
    },


  ];

  return (
    <>
      <div className="service-grid-box f-wrp">
        <div className="row">
          {serviceListing.map((element, key) => (

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 each-service-items f-wrp" key={key}>
              <div className="service-box f-wrp">
                <div className="propList-bg f-wrp">
                  {element.serviceIcon ? <span className='serviceIcon'><img src={element.serviceIcon} alt="service" /></span> : null}
                </div>
                <div className="propList-item-blk f-wrp">
                  {element.serviceTitle ? <h1>{element.serviceTitle}</h1> : null}
                  {element.Description ? <p>{element.Description}</p> : null}
                </div>
              </div>
            </div>

          ))}
        </div>
      </div>
    </>
  );
}

export default ServicesGrid;